export default __webpack_public_path__ + "static/media/confusionImg_5.b1ac1190.webp";